import { useEffect, useState } from 'react';

const KEY = 'blackjack-trainer-state-v1';

export function loadPersisted(defaults) {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    return deepMerge(defaults, parsed);
  } catch {
    return defaults;
  }
}

export function savePersisted(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // quota or private mode — silently ignore
  }
}

export function useRootState(defaults) {
  const [state, setState] = useState(() => loadPersisted(defaults));
  useEffect(() => {
    savePersisted(state);
  }, [state]);
  return [state, setState];
}

// Returns a setter that updates a nested path immutably.
export function patch(setState, path) {
  return (value) =>
    setState((prev) => {
      const next = structuredClone(prev);
      let cur = next;
      for (let i = 0; i < path.length - 1; i++) cur = cur[path[i]];
      cur[path[path.length - 1]] = typeof value === 'function' ? value(cur[path[path.length - 1]]) : value;
      return next;
    });
}

function deepMerge(base, override) {
  if (Array.isArray(base) || typeof base !== 'object' || base === null) return override ?? base;
  if (typeof override !== 'object' || override === null) return base;
  const out = { ...base };
  for (const k of Object.keys(override)) {
    out[k] = deepMerge(base[k], override[k]);
  }
  return out;
}
